import { createFileRoute } from '@tanstack/react-router';
import LandingPage from '@/features/landing/LandingPage';

export const Route = createFileRoute('/')({
  // Whitelisted into SSR (router default is `false` via createStart).
  // Crawlers + first paint matter on the landing page; auth-gated routes
  // stay CSR because they read sessionStorage which is browser-only.
  ssr: true,
  component: LandingPage,
});
